import React, { useState, useEffect } from 'react';
import "../../../pages/client/client_assets/css/Surveys.css";
import right_arrow from '../../../pages/client/client_assets/img/right_arrow.svg';
import { Link } from "react-router-dom";

const Surveys = () => {

 

    // State to hold the survey counts
    const [surveyCounts, setSurveyCounts] = useState({
        customer_count: 0,
        employee_count: 0,
        investor_count: 0,
        partner_count: 0
    });

    // Fetch survey counts when component mounts
    useEffect(() => {
        fetch("https://api.skepper.in/get_survey_counts.php", {
            credentials: "include"
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                setSurveyCounts(data.data);  // Update state with fetched data
            }
        })
        .catch(error => console.error("Error fetching survey data:", error));
    }, []);

    return (
        <div >
            <div className='survey_sec'>
                <h1 className='dashboard_heading text-start'>Surveys</h1>

                <div className='survey_container shadow-none'>
                    <div className='survey_wrapper py-0 first_wrap d-flex justify-content-between rounded-0'>
                        <div className='survey_category d-flex align-items-end'>
                            <div className='category_pic'>
                            </div>
                            <div className='category_name'>
                            </div>
                        </div>
                        <div className='total_response d-flex justify-content-between align-items-center'>
                            <div className='responses top_txt_response'>
                                <p className='mb-0'>Responses</p>
                            </div>
                            <div className='right_arrow'>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Customer Survey Link */}
                <Link to="/client/customer-form" className='text-decoration-none'>
                    <div className='survey_wrapper d-flex justify-content-between bg-white'>
                        <div className='survey_category d-flex align-items-end'>
                            <div className='category_pic'>
                                <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/arrow.svg" alt="" />
                            </div>
                            <div className='category_name'>
                                <p className='text-dark'>Customer</p>
                            </div>
                        </div>
                        <div className='total_response d-flex justify-content-between align-items-center'>
                            <div className='responses'>
                                <p className='mb-0 text-dark'>{surveyCounts.customer_count}</p> {/* Dynamic count */}
                            </div>
                            <div className='right_arrow'>
                                <img src={right_arrow} alt="arrow" />
                            </div>
                        </div>
                    </div>
                </Link>

                {/* Employee Survey Link */}
                <Link to="/client/employee-form" className='text-decoration-none my-4'>
                    <div className='survey_wrapper d-flex justify-content-between bg-white'>
                        <div className='survey_category d-flex align-items-end'>
                            <div className='category_pic'>
                                <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/arrow.svg" alt="" />
                            </div>
                            <div className='category_name'>
                                <p className='text-dark'>Employee</p>
                            </div>
                        </div>
                        <div className='total_response d-flex justify-content-between align-items-center'>
                            <div className='responses'>
                                <p className='mb-0 text-dark'>{surveyCounts.employee_count}</p> {/* Dynamic count */}
                            </div>
                            <div className='right_arrow'>
                                <img src={right_arrow} alt="arrow" />
                            </div>
                        </div>
                    </div>
                </Link>

                {/* Partner Survey Link */}
                <Link to="/client/partner-form" className='text-decoration-none'>
                    <div className='survey_wrapper d-flex justify-content-between bg-white'>
                        <div className='survey_category d-flex align-items-end'>
                            <div className='category_pic'>
                                <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/arrow.svg" alt="" />
                            </div>
                            <div className='category_name'>
                                <p className='text-dark'>Partner</p>
                            </div>
                        </div>
                        <div className='total_response d-flex justify-content-between align-items-center'>
                            <div className='responses'>
                                <p className='mb-0 text-dark'>{surveyCounts.partner_count}</p> {/* Dynamic count */}
                            </div>
                            <div className='right_arrow'>
                                <img src={right_arrow} alt="arrow" />
                            </div>
                        </div>
                    </div>
                </Link>

                {/* Investor Survey Link */}
                <Link to="/client/investor-form" className='text-decoration-none'>
                    <div className='survey_wrapper d-flex justify-content-between bg-white'>
                        <div className='survey_category d-flex align-items-end'>
                            <div className='category_pic'>
                                <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/arrow.svg" alt=""/>
                            </div>
                            <div className='category_name'>
                                <p className='text-dark'>Investor</p>
                            </div>
                        </div>
                        <div className='total_response d-flex justify-content-between align-items-center'>
                            <div className='responses'>
                                <p className='mb-0 text-dark'>{surveyCounts.investor_count}</p>
                            </div>
                            <div className='right_arrow'>
                                <img src={right_arrow} alt="arrow" />
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
        </div>

  );
}

export default Surveys;
